module.exports = __webpack_public_path__ + "img/title2.9e9c8bc5.png";